import { SidebarTrigger, useSidebar } from "@/components/ui/sidebar";
import { Separator } from "@/components/ui/separator";
import { Breadcrumb, BreadcrumbList, BreadcrumbItem, BreadcrumbLink, BreadcrumbSeparator, BreadcrumbPage } from "@/components/ui/breadcrumb";
import { useLocation } from "wouter";
import { ChevronRight, Home, Slash } from "lucide-react";
import { cn } from "@/lib/utils";
import { Button } from "@/components/ui/button";

export function AppHeader() {
  const [location] = useLocation();
  const { state } = useSidebar();

  // Generate breadcrumbs from the current path
  const generateBreadcrumbs = (): Array<{ label: string; href: string; isLast?: boolean }> => {
    const paths = location.split("/").filter(Boolean);

    if (paths.length === 0) {
      return [{ label: "Dashboard", href: "/", isLast: true }];
    }

    const breadcrumbs: Array<{ label: string; href: string; isLast?: boolean }> = [{ label: "Dashboard", href: "/" }];

    let currentPath = "";
    paths.forEach((path, index) => {
      currentPath += `/${path}`;
      const label = path
        .split("-")
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ");

      breadcrumbs.push({
        label,
        href: currentPath,
        isLast: index === paths.length - 1,
      });
    });

    return breadcrumbs;
  };

  const breadcrumbs = generateBreadcrumbs();

  return (
    <header className="sticky top-0 z-40 flex h-14 shrink-0 items-center gap-2 border-b bg-background px-4">
      <div className="flex items-center gap-3 flex-1">
        {/* Breadcrumbs */}
        <Breadcrumb>
          <BreadcrumbList className="flex items-center">
            {breadcrumbs.map((crumb, index) => (
              <BreadcrumbItem key={crumb.href} className="hidden sm:flex items-center">
                {index > 0 && (
                  <BreadcrumbSeparator className="mx-2">
                    <ChevronRight className="h-3.5 w-3.5 text-muted-foreground" />
                  </BreadcrumbSeparator>
                )}
                {crumb.isLast ? (
                  <BreadcrumbPage className="font-medium text-foreground">
                    {crumb.label}
                  </BreadcrumbPage>
                ) : (
                  <BreadcrumbLink
                    href={crumb.href}
                    className="text-muted-foreground hover:text-foreground transition-colors"
                  >
                    {index === 0 && <Home className="h-3.5 w-3.5 mr-1.5 inline-block" />}
                    {crumb.label}
                  </BreadcrumbLink>
                )}
              </BreadcrumbItem>
            ))}
          </BreadcrumbList>
        </Breadcrumb>
      </div>
    </header>
  );
}
